import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IconComponent } from "../../../shared/components/icon/icon.component";
import { INotification } from '../../models/notification';
import { AcademicClassActions } from '../../store/academics/academic.actions';
import { NotificationActions } from '../../store/notifications/notification.actions';
import { StudentActions } from '../../store/students/student.actions';

@Component({
  selector: 'app-snackbar', standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  constructor(
    public snackBarRef: MatSnackBarRef<NotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: INotification
  ) { }

  onClose(clickEvent: MouseEvent): void {
    clickEvent.stopPropagation();
    this.snackBarRef.dismiss();
  }

  routeTo() {
    if (this.data.url) {
      this.data.relatedIds?.forEach(id => {
        switch (id.name) {
          case 'student':
            // Dispatch the action for selecting a student
            this.store.dispatch(StudentActions.selectStudent({ id: id.identifier }));
            break;

          case 'class':
            // Dispatch the action for selecting a class
            this.store.dispatch(AcademicClassActions.selectClass({ id: id.identifier }));
            break;

          default:
            console.warn(`Unknown id name: ${id.name}`);
        }
      });
      this.router.navigate([this.data.url]);
    }
    this.store.dispatch(NotificationActions.markAsRead({ id: this.data.id }))
    this.snackBarRef.dismiss();
  }
}
